import { useDataSubmit } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let submit = useDataSubmit({
    context: 'patient',
    viewPath: props.viewPath,
  })
  return function onChange(value) {
    return submit({ type: 'updateDialog' })
  }
}
